import actions from './action';
import mutations from './mutations';
export const state = { fondo: undefined, chatId: undefined, active: false };
const namespaced = true;
const chatModule = { state, actions, mutations, namespaced };
export default chatModule;
